import React, { useState } from 'react';
import * as XLSX from 'xlsx';

import { useDispatch, } from 'react-redux';
import { importAnnouncementData } from '../../store/actions/announcement';

const UploadXlsx = () => {

  const dispatch = useDispatch();

  const [data, setData] = useState([]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const data = reader.result;
        const parsedData = parseExcelData(data);
        setData(parsedData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const parseExcelData = (excelData) => {
    const workbook = XLSX.read(excelData, { type: 'array' });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(sheet);

    let parsedData = [];
    let lastItem = null;

    jsonData.forEach((row) => {
      const wasteCode = row['__EMPTY_2'];
      const wasteName = row['__EMPTY_8'];
      const company = row['__EMPTY_35'];

      // Filtrujeme nežiaduce riadky podľa obsahu
      const unwantedHeaders = [
        // 'Kód odpadu podľa Katalógu odpadov',
        '2', '3', '4', '6', '7', '8', '9',
      ];
      

      if (wasteCode && !unwantedHeaders.includes(wasteCode.toString())) {
        lastItem = {
          wasteCode: wasteCode || '',
          wasteName: wasteName || '',
          wasteCategory: row['__EMPTY_17'] || '',
          yCode: row['__EMPTY_20'] || '',
          wasteWeight: row['__EMPTY_25'],
          loadingCode: row['__EMPTY_32'] || '',
          identificationNumber: [
            row['__EMPTY_35'],
            row['__EMPTY_37'],
            row['__EMPTY_39'],
            row['__EMPTY_41'],
            row['__EMPTY_43'],
            row['__EMPTY_45'],
            row['__EMPTY_47'],
            row['__EMPTY_49'],
          ].filter((num) => num !== '' && num != null).map(String),
          acronym: row['__EMPTY_51'] || '',
          company,
        };
   
        parsedData.push(lastItem);
      } 
      else if (company && typeof company === 'string' && lastItem) {
        lastItem.company = company;
      }
      
    });

    // Retype identificationNumber array to string
    const proccesedData = parsedData
      .filter(item => item.wasteCode !== 'Kód odpadu podľa Katalógu odpadov')
      .map(item => ({
        ...item, // Skopírujeme všetky existujúce vlastnosti
        identificationNumber: item.identificationNumber.join('') // Spracujeme identificationNumber ako string
      }));

      dispatch(importAnnouncementData(proccesedData));

    return parsedData;
  };

  return (
    <div>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      {/* <table>
        <thead>
          <tr>
            <th>Waste Code</th>
            <th>Waste Name</th>
            <th>Waste Category</th>
            <th>Y code</th>
            <th>Waste Weight</th>
            <th>Loading Code</th>
            <th>Identification Number</th>
            <th>Acronym</th>
            <th>Company</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.wasteCode}</td>
              <td>{item.wasteName}</td>
              <td>{item.wasteCategory}</td>
              <td>{item.yCode}</td>
              <td>{item.wasteWeight}</td>
              <td>{item.loadingCode}</td>
              <td>{item.identificationNumber.join(', ')}</td>
              <td>{item.acronym}</td>
              <td>{item.company}</td>
            </tr>
          ))}
        </tbody>
      </table> */}
    </div>
  );
};

export default UploadXlsx;
